<ul class="tw-flex">
  <li *ngFor="let breadCrumb of breadCrumbs; let last = last; let first = first;" class="tw-uppercase tw-text-sm tw-font-bold">
    <ng-container *ngIf="first || !last; else els;">
      <a href="{{breadCrumb.value}}">{{breadCrumb.key}}</a>
      <span class="tw-px-1">/</span>
    </ng-container>
    <ng-template #els>
      <span class="tw-text-grayMid">{{breadCrumb.key}}</span>
    </ng-template>
  </li>
</ul>